/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { DraftLatestIssueRequestDidMethod } from '../../types/DraftLatestIssueRequestDidMethod';

export const DraftLatestIssueRequest: core.serialization.Schema<
    serializers.DraftLatestIssueRequest.Raw,
    Omit<Truvity.DraftLatestIssueRequest, 'ifMatch'>
> = core.serialization.object({
    didMethod: core.serialization.property('did_method', DraftLatestIssueRequestDidMethod.optional()),
    issuer: core.serialization.string().optional(),
    keyId: core.serialization.property('key_id', core.serialization.string()),
    prerequisiteDrafts: core.serialization.property(
        'prerequisite_drafts',
        core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    ),
    strictMode: core.serialization.property('strict_mode', core.serialization.boolean().optional()),
    validFrom: core.serialization.property('valid_from', core.serialization.date().optional()),
    validUntil: core.serialization.property('valid_until', core.serialization.date().optional()),
});

export declare namespace DraftLatestIssueRequest {
    export interface Raw {
        did_method?: DraftLatestIssueRequestDidMethod.Raw | null;
        issuer?: string | null;
        key_id: string;
        prerequisite_drafts?: Record<string, string> | null;
        strict_mode?: boolean | null;
        valid_from?: string | null;
        valid_until?: string | null;
    }
}
